module.exports = __webpack_public_path__ + "static/media/tango_account.1d8bcb49.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new_menu_icons/tango_account.svg
// module id = 2721
// module chunks = 0